import styled from 'styled-components';

const ConversionResultsValueLabel = styled.span`
    cursor: pointer;
`;

export default ConversionResultsValueLabel;
